import { createStandaloneToast } from '@chakra-ui/react';

const toast = createStandaloneToast();

export const notifyError = (message?: string) => {
  toast({
    description: message ?? 'Ocorreu um erro na requisição.',
    status: 'error',
    duration: 5000,
    isClosable: true,
  });
};
